import { goto } from '$app/navigation';
import { page } from '$app/state';

export const handleNav = (e) => {
	// Prevent default link behavior
	if (e.preventDefault) {
		e.preventDefault();
	}

	// Get href from the clicked element
	const href = e.currentTarget?.getAttribute('href');

	const persistSearch = e.currentTarget?.getAttribute('persistSearch') === 'true';
	gotoHref(href, persistSearch);

};

export const gotoHref = async (href, persistSearch = false) => {
	if (!href) return;

	// external or tel: links
	if (href.startsWith('http')) {
		window.open(href, '_blank', 'noopener,noreferrer');
		return;
	}
	if (href.startsWith('tel:')) {
		window.location.href = href;
		return;
	}

	// close mobile drawer
	const drawer = document.getElementById('mobile-menu-drawer');
	if (drawer) drawer.checked = false;

	// handle query params
	const newUrl = new URL(href, window.location.origin);
	let newHref = newUrl.pathname;
	const newParams = new URLSearchParams(newUrl.search);

	// persist search parameters in url
	// Default is to NOT persist unless persistSearch or persist=true
	if (persistSearch || newParams.get('persist') === 'true') {
		const currentParams = new URLSearchParams(page.url.search);

		// Only add current params if not already in new
		currentParams.forEach((value, key) => {
			if (!newParams.has(key)) newParams.set(key, value);
		});
	}

	if (newParams.size > 0) newHref += `?${newParams.toString()}`;

	const hash = newUrl.hash;
	if (hash) newHref += hash;

	const scrollToHash = (hash) => {
		const target = hash ? document.getElementById(hash.slice(1)) : null;
		const container = target ? target.parentElement : document.getElementById('main-scrollable-container');
		let targetOffset = 0;
		if (target) {
			const targetTop = target.getBoundingClientRect().top;
			const containerTop = container.getBoundingClientRect().top;
			const containerScrollTop = container.scrollTop;
			targetOffset =
				targetTop -
				containerTop +
				containerScrollTop;
		}
		container.scrollTo({ top: targetOffset, behavior: 'smooth' });
	};

	await goto(newHref, { replaceState: false });

	setTimeout(() => {
		scrollToHash(hash);
	}, 50);
};
